import { createRouter, createWebHistory } from "vue-router";
import rapsotecRouterMiddleware from "@/router/rapsotecRouterMiddleware.js";
import posthog from "posthog-js";
const Rapsotec = () => import(/* webpackChunkName: "Rapsotec" */ "@/components/Rapsotec.vue");
const OidcCallback = () =>
  import(/* webpackChunkName: "OidcCallback" */ "@/components/OIDCCallback.vue");
const EmbeddedDMS = () =>
  import(/* webpackChunkName: "EmbeddedDMS" */ "@/components/EmbeddedDMS.vue");
const UnrecognizedUser = () =>
  import(/* webpackChunkName: "UnrecognizedUser" */ "@/components/UnrecognizedUser.vue");

import RapsotecChildrens from "./childrens/RapsotecChildrens";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: Rapsotec,
      meta: {
        isPublic: false,
      },
      children: RapsotecChildrens,
    },
    {
      path: "/oidc-callback",
      name: "oidcCallback",
      component: OidcCallback,
      meta: {
        isVuexOidcCallback: true,
        isPublic: true,
      },
    },
    {
      path: "/embed/dms",
      name: "embed-dms",
      component: EmbeddedDMS,
      meta: {
        isVuexOidcCallback: false,
        isPublic: true,
      },
    },
    {
      path: "/unrecognized",
      name: "unrecognized-user",
      component: UnrecognizedUser,
      meta: {
        isVuexOidcCallback: false,
        isPublic: true,
      },
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/",
    },
  ],
});

router.beforeEach(rapsotecRouterMiddleware());

/**
 * This guard is used to avoid the error "Missing required param" when navigating to base route
 * https://github.com/vuejs/router/issues/845
 * it was mostly happening when navigating back to the projectsList route on mobile
 * here we implement a list of routes that could potentially be affected by this error
 */
router.beforeEach((to, from, next) => {
  // List of routes that should not inherit params from previous routes
  const routesWithoutInheritedParams = ["projectsList", "Dashboard"];
  let sanitizedParams = { ...to.params };
  if (routesWithoutInheritedParams.some((routeName) => to.name?.includes(routeName))) {
    Object.keys(from.params).forEach((key) => {
      // Remove projectId param when navigating to Dashboard to avoid "Missing required param" error
      if (to.params[key] === undefined) {
        to.params[key] = " ";
        sanitizedParams = { ...sanitizedParams, [key]: " " };
      }
    });
  }
  // RO- 23-02-2026: fix: Remove trailing slashes from routes (except root)
  if (to.path !== "/" && to.path.endsWith("/")) {
    let path = to.path;
    while (path.length > 1 && path.endsWith("/")) {
      path = path.slice(0, -1);
    }
    return next({
      path,
      query: to.query,
      hash: to.hash,
      params: sanitizedParams,
    });
  }
  next();
});

router.afterEach((to) => {
  posthog.capture("$pageview", {
    $current_url: globalThis.location.href,
    path: to.fullPath,
  });
});

export default router;
